module.exports = "<crm-loader></crm-loader>\n<router-outlet></router-outlet>\n"